import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {StyleSheet, css} from 'aphrodite';

const imgWidth = {
    width: '100%',
    height: '180px',
};

const Dispatch = (dispatch) => {
    return {
        reserva: (e) =>{
            let index = e.target.getAttribute('data-index');
            const action = {
                type: 'reserva',
                index: index
            }
            dispatch(action);
        }
    }
}

class EventCard extends Component {
    componentDidMount=()=> {
        document.getElementById('event-'+this.props.index).innerHTML = this.props.children;
    }
    render(){
        return (
            <div className="card__events">
                <div className="card__events--item">
                    <div className="row card__events">
                        <div className="card__events--image col-lg-3 col-sm-12">
                            <img className="mr-3" style={imgWidth} src={this.props.featuredImage} alt={this.props.name} />
                        </div>
                        <div className="card__events--details col-lg-9 col-sm-12">
                            <div className="card__events--name">
                                <h4>{this.props.name}</h4>
                            </div>
                            <div className="card__events--content">
                                <p className={css(styles.paragraphStyle)} id={"event-"+this.props.index}></p>
                            </div>
                            <div className="card__events--pricing d-block" style={{marginTop: '18px'}}>
                                <div className="d-inline">
                                    <span className="card__events--capacityText">
                                        Fecha: <strong>24/09/2018</strong> | Capacidad Máxima: {this.props.capacity}
                                    </span>
                                </div>
                                <div className="d-inline float-right">
                                    {this.props.available === true?
                                        <Link to={'/detail/' + this.props.name} 
                                            onClick={this.props.reserva} 
                                            data-index={this.props.index} 
                                            className="btn btn-events">
                                                Comprar Boletas
                                        </Link>
                                    :
                                        <a  className="btn btn-events disabled-event">Proximamente</a>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
EventCard.propTypes = {
    name: PropTypes.string.isRequired,
    capacity: PropTypes.number.isRequired,
    featuredImage: PropTypes.string.isRequired,
}
const styles = StyleSheet.create({
    paragraphStyle: {
        fontSize: '15px',
        color: '#8D8D8D',
        fontWeight: '400',
        minHeight: '66px',
    }
})
export default connect(null,Dispatch)(EventCard);


// WEBPACK FOOTER //
// ./src/Components/Events/eventCard.js